
import get from "lodash-es/get";
import isString from "lodash-es/isString";

import Vue from "vue";
import Component, { mixins } from "vue-class-component";

import { Prop } from "vue-property-decorator";

import {
  AUTHENTICATE_USER,
  FETCH_PIPELINES,
  SET_GLOBAL_SNACKBAR,
  SET_USER_PROFILE,
} from "../store";
import { WebAPI } from "../web-api";

import { Snackbar } from "../snackbar";

import { CopyToClipboard } from '../clipboard-mixin';

@Component({})
export default class UserProfile extends mixins(CopyToClipboard) {

  public hideToken = true;

  public get is_authenticated(): boolean {
    return this.$store.getters.is_authenticated;
  }

  public get full_name(): string {
    const name = get(this.$store.state.user_profile, "full_name", null);
    if (!name || (isString(name) && !name.trim())) {
      return "Anonymous User";
    }
    return name;
  }

  public get username(): string {
    return get(this.$store.state.user_profile, "username", "anonymous");
  }

  public get user_id(): string {
    return get(this.$store.state.user_profile, "id", null);
  }

  public get email(): string {
    return get(this.$store.state.user_profile, "email", null);
  }

  public get profile_pic_url(): string {
    return get(this.$store.state.user_profile, "profile_pic", null);
  }

  public get openAPIUrl(): string {
    return WebAPI.baseUrl + "/api/v1/schema/swagger-ui/";
  }

  public get api_auth_token(): string {
    return get(this.$store.state.user_profile, "token", "");
  }

  public get masked_api_auth_token(): string {
    const token: string = this.api_auth_token;
    if (this.hideToken) {
      return "•".repeat(token.length)
    }

    return token;
  }

  toggleTokenVisibility() {
    this.hideToken = !this.hideToken;
  }

  copyTokenToClipboard() {
    // from CopyToClipboard mixin
    this.setClipboardFlash(this.api_auth_token, "Secret API token copied to clipboard");
  }

  openDialog(refName: string) {
    // console.log('Opened: ' + refName);
    ((this.$refs as any)[refName] as any).open();
  }

  closeDialog(refName: string) {
    // console.log('Closed: ' + refName);
    ((this.$refs as any)[refName] as any).close();
  }

  public async created() { }
}
